import React from "react";
import { MarkupText } from "./MarkupText";
export function ParagraphTwoColumnsText(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "paragraph-container container-page flex flex-col items-start md:items-center"
    }, !props.isNested ? /*#__PURE__*/ React.createElement("h2", null, props.title) : /*#__PURE__*/ React.createElement("h3", null, props.title), /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 md:grid-cols-2 gap-8 items-start md:self-center md:w-[90%]"
    }, !!props.textLeft && /*#__PURE__*/ React.createElement("section", {
        className: "w-full"
    }, /*#__PURE__*/ React.createElement(MarkupText, {
        markup: props.textLeft
    })), !!props.textRight && /*#__PURE__*/ React.createElement("section", {
        className: "w-full"
    }, /*#__PURE__*/ React.createElement(MarkupText, {
        markup: props.textRight
    }))));
}
